import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const automationRuleDependencies: RequestModuleEnum[] = [
  RequestModuleEnum.Community,
  RequestModuleEnum.Tags,
  RequestModuleEnum.MembershipCourse,
  RequestModuleEnum.MembershipCourseCurriculum,
  RequestModuleEnum.MembershipLightCourse,
  RequestModuleEnum.MembershipLightCourseCurriculum,
  RequestModuleEnum.MembershipCourseLecture,
  RequestModuleEnum.CourseBundle,
  RequestModuleEnum.WhiteLabel,
  RequestModuleEnum.Campaign,
  RequestModuleEnum.SmsTemplates,
]
